export const ErmineQueryKey = {
    GetTermsOfService: (portalArn: string, userSettingsId: string) => [
        "ErmineSSR",
        "GetTermsOfService",
        portalArn,
        userSettingsId ?? "",
    ],
};
